import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { translator } from "../../utils/i18n";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Tooltip from "@material-ui/core/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { downloadFiles } from "../../utils/fetcher";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import GetAppIcon from "@material-ui/icons/GetApp";
import Link from "@material-ui/core/Link";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default function Download(props) {
  const dispatch = useDispatch();
  const files = useSelector(state => state.patientArea.files);
  const downloadFileFunc = (id, doctorId) =>
    dispatch(downloadFiles(id, doctorId));

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    dispatch(() => downloadFileFunc(props.id, props.doctorId));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={translator()._("W_TELECHARGER")}>
        <Button
          className="no-bg attachment-btn"
          variant="outlined"
          onClick={handleClickOpen}
        >
          <CloudDownloadIcon />
        </Button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="download-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="download-dialog-title" onClose={handleClose}>
          {translator()._("W_TELECHARGER")}
        </DialogTitle>
        <DialogContent dividers>
          {files && files.length > 0 && (
            <List>
              {files.map((file, key) => (
                <ListItem
                  key={key}
                  button
                  component={Link}
                  href={file.file}
                  target="_blank"
                  rel="noopener"
                >
                  <ListItemAvatar>
                    <Avatar>
                      <GetAppIcon color="primary" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={file.nom_document_file_rdv || "Nom fichier"}
                    secondary={file.dateenreg}
                  />
                </ListItem>
              ))}
            </List>
          )}
          {files && files.length === 0 && (
            <div>{translator()._("W_NO_FILE")}</div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

Download.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
